export default class Faq {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        var faqContainer = document.querySelector('.faq__container');
        var faqCollapsible = faqContainer.querySelector('.faq__collapsible-content');
        var buttons = [];
        var expandButton = document.querySelector('.faq__expand-button');
        if (expandButton) {
            buttons.push(expandButton)
        }
        var collapseButton = document.querySelector('.faq__collapse-button');
        if (collapseButton) {
            buttons.push(collapseButton)
        }
        buttons.forEach(button => {
            button.onclick = () => {
                if (faqContainer.classList.contains('collapsed')) {
                    faqContainer.classList.remove('collapsed');
                    faqCollapsible.setAttribute('aria-expanded', 'true');
                    expandButton.innerHTML = 'Collapse';
                } else {
                    faqContainer.classList.add('collapsed');
                    faqCollapsible.setAttribute('aria-expanded', 'false');
                    expandButton.innerHTML = 'View more...';
                }
            }
        });
    }
}